/* Reading position only: the story remains visible and navigable without JavaScript. */
(() => {
  function init(root) {
    if (root.dataset.storyReady) return;
    root.dataset.storyReady = 'true';
    const chapters = [...root.querySelectorAll('[data-story-chapter]')];
    const links = [...root.querySelectorAll('[data-story-link]')];
    const progress = root.querySelector('[data-story-progress]');
    if (!chapters.length) return;
    let frame;
    function update() {
      frame = null;
      const readingLine = Math.min(innerHeight * .3, 240);
      let current = chapters[0];
      chapters.forEach(chapter => { if (chapter.getBoundingClientRect().top <= readingLine) current = chapter; });
      links.forEach(link => {
        if (link.hash === '#' + current.id) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      const first = chapters[0].getBoundingClientRect();
      const last = chapters[chapters.length - 1].getBoundingClientRect();
      const amount = Math.max(0, Math.min(1, (readingLine - first.top) / Math.max(1, last.bottom - first.top)));
      if (progress) progress.style.width = `${amount * 100}%`;
    }
    function requestUpdate() { if (!frame) frame = requestAnimationFrame(update); }
    addEventListener('scroll', requestUpdate, {passive:true});
    addEventListener('resize', requestUpdate);
    root.cleanupStory = () => { cancelAnimationFrame(frame); removeEventListener('scroll', requestUpdate); removeEventListener('resize', requestUpdate); };
    update();
  }
  document.querySelectorAll('[data-shani-story]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-shani-story]').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-shani-story]').forEach(root => root.cleanupStory?.()));
})();
